export const FEATURE_FLAG_EXPERIMENT_COOKIE_NAME = 'x-flag-exp'
export const FEATURE_FLAG_INTERNAL_COOKIE_NAME = 'x-flag-internal'

export const flags = {
  FLAG_EXPEDITED_SHIPPING_DISABLED:
    'my-pga-com-jrl-expedited-shipping-disabled',
  FLAG_FEAT_GROUP_EVENT_RECURRING_PAYMENTS_ENABLED:
    'my-pga-com-feat-group-event-recurring-payments-enabled',
  FLAG_STUDENT_REVENUE_STAT: 'my-pga-com-student-revenue-statistic',
  FLAG_FEAT_BYPASS_JRL_REG: 'my-pga-com-jrl-registration-date-bypass',
  FLAG_FEAT_COACH_BUSINESS_INSIGHTS: 'my-pga-com-coach-business-insights',
  FLAG_FEAT_COACH_ANALYTICS: 'my-pga-com-feat-coach-analytics',
  FLAG_GROUP_EVENT_PAYMENT_INTENTS: 'my-pga-com-group-event-payment-intents',
  FLAG_GROUP_EVENT_PAYMENT_LINKS: 'my-pga-com-group-event-payment-links',
  FLAG_CUSTOM_AVAILABILITY: 'my-pga-com-custom-availability',
}
